import {
	LOGIN,
	LOGIN_SUCCESS,
	LOGIN_FAILURE,
	AUTO_LOGIN,
	SOCIAL,
	SOCIAL_SUCCESS,
	SOCIAL_FAILURE,
	LOGIN_RESET,
	LOGOUT,
	GET_AUTH_LINK,
	START_SYNC,
} from './types';

export const loginAction = (payload: any) => ({
	type: LOGIN,
	payload,
});

export const loginSuccessAction = (userToken: string) => ({
	type: LOGIN_SUCCESS,
	payload: userToken,
});

export const loginFailureAction = (error: Error) => ({
	type: LOGIN_FAILURE,
	payload: error,
});

export const socialAction = (payload: any) => ({
	type: SOCIAL,
	payload,
});

export const socialSuccessAction = (userToken: string) => ({
	type: SOCIAL_SUCCESS,
	payload: userToken,
});

export const socialFailureAction = (error: Error) => ({
	type: SOCIAL_FAILURE,
	payload: error,
});

export const autoLoginAction = () => ({
	type: AUTO_LOGIN,
});

export const getAuthLinkAction = (payload: any) => ({
	type: GET_AUTH_LINK,
	payload,
});

export const startSyncAction = () => ({
	type: START_SYNC,
});

export const loginResetAction = () => ({
	type: LOGIN_RESET,
});

export const logoutAction = () => ({
	type: LOGOUT,
});
